import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import Vuelidate from 'vuelidate';
import 'vant/lib/index.css';
import './common/scss/common.scss';
import 'lib-flexible'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import _ from 'lodash'
import VueClipBoard from 'vue-clipboard2'

Vue.prototype._ = _
Vue.use(VideoPlayer)
Vue.use(Vant);

Vue.use(Vuelidate);
Vue.use(VueClipBoard)
Vue.config.productionTip = false
Vue.prototype.$global = {
    url: ''
}
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')